import React from 'react';

const VersionBadge = ({ 
  isLatest = false, 
  releaseType = 'production', 
  isActive = true 
}) => {
  
  const getBadgeConfig = () => {
    if (isLatest) {
      return {
        text: 'Latest',
        color: '#27ae60',
        backgroundColor: '#d5f4e6',
        icon: '⭐'
      };
    }
    
    switch (releaseType) {
      case 'alpha':
        return {
          text: 'Alpha',
          color: '#e67e22',
          backgroundColor: '#fdebd0',
          icon: '🔬'
        };
      case 'beta':
        return {
          text: 'Beta',
          color: '#3498db',
          backgroundColor: '#d6eaf8',
          icon: '🧪'
        };
      case 'production':
      default:
        return {
          text: 'Stable',
          color: '#27ae60',
          backgroundColor: '#d5f4e6',
          icon: '✓'
        };
    }
  };

  const getStatusBadge = () => {
    if (!isActive) {
      return {
        text: 'Inactive',
        color: '#95a5a6',
        backgroundColor: '#ecf0f1',
        icon: '○'
      };
    }
    return null;
  };

  const badgeConfig = getBadgeConfig();
  const statusBadge = getStatusBadge();

  return (
    <div style={styles.container}>
      <span 
        style={{
          ...styles.badge,
          color: badgeConfig.color,
          backgroundColor: badgeConfig.backgroundColor
        }}
      >
        <span style={styles.icon}>{badgeConfig.icon}</span>
        {badgeConfig.text}
      </span>
      
      {statusBadge && (
        <span 
          style={{
            ...styles.badge,
            color: statusBadge.color,
            backgroundColor: statusBadge.backgroundColor
          }}
        >
          <span style={styles.icon}>{statusBadge.icon}</span>
          {statusBadge.text}
        </span>
      )}
    </div>
  );
};

const styles = {
  container: {
    display: 'flex',
    gap: '8px',
    alignItems: 'center',
    flexWrap: 'wrap'
  },
  badge: {
    display: 'inline-flex',
    alignItems: 'center',
    padding: '4px 12px',
    borderRadius: '12px',
    fontSize: '12px',
    fontWeight: '600',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
    transition: 'all 0.2s ease'
  },
  icon: {
    marginRight: '4px',
    fontSize: '14px'
  }
};

export default VersionBadge;
